import { FormControl, FormGroup } from '@angular/forms';

export const getFormControl = (form: FormGroup, formControlName: string): FormControl => form.get(formControlName) as FormControl;
